import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
export function Biography() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  // Subtle parallax for text
  const y = useTransform(smoothProgress, [0, 1], [40, -40]);
  const opacity = useTransform(smoothProgress, [0.1, 0.3], [0, 1]);
  // Line animation linked to scroll
  const lineWidth = useTransform(smoothProgress, [0.15, 0.45], [0, 64]); // 64px = w-16
  return <section ref={containerRef} className="py-24 md:py-40 bg-ivory relative overflow-hidden" data-id="element-1">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-2">
        <motion.div style={{
        y,
        opacity
      }} className="relative z-10" data-id="element-3">
          <div className="flex justify-center mb-8" data-id="element-4">
            <motion.div style={{
            width: lineWidth
          }} className="h-[1px] bg-gold" data-id="element-5" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-softBlack mb-12" data-id="element-6">
            Biografía
          </h2>

          <div className="space-y-8 text-lg text-warmGray leading-relaxed font-light" data-id="element-7">
            <motion.p style={{
            opacity: useTransform(smoothProgress, [0.2, 0.4], [0, 1]),
            y: useTransform(smoothProgress, [0.2, 0.4], [20, 0])
          }} data-id="element-8">
              Cindy Salloum Echeto es esteticista profesional especializada en
              el cuidado integral de la piel y el bienestar estético. Su enfoque
              combina técnica, detalle y una atención cercana que respeta la
              historia de cada rostro. Para Cindy, la estética no se trata de
              perfección, sino de armonía: piel saludable, confianza y una
              experiencia que te devuelva calma.
            </motion.p>
            <motion.p style={{
            opacity: useTransform(smoothProgress, [0.3, 0.5], [0, 1]),
            y: useTransform(smoothProgress, [0.3, 0.5], [20, 0])
          }} data-id="element-9">
              A lo largo de su trayectoria, ha acompañado a mujeres que desean
              verse frescas y luminosas sin perder su esencia. Sus protocolos se
              basan en evaluación personalizada, hábitos de cuidado en casa y
              tratamientos que priorizan resultados progresivos y naturales.
              Cada cita está diseñada como un espacio seguro: limpio,
              profesional y dedicado a ti.
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}